
import Main from "@/views/Main.vue";

const customerRoutes = [
  {
    path: "/wholesaleOrder",
    icon: "android-menu",
    name: "现货批发",
    title: "现货批发",
    component: Main,
    children: [
      {
        path: "index",
        title: "批发订单集合",
        name: "WholesaleOrderList",
        component: resolve => {
          require(["@/views/wholesaleOrder/index.vue"], resolve);
        }
      },
    ]
  },
]

export default customerRoutes
